export const COIN = "USDS";
export const GT = "SABLE";
export const LP = "UNI LP";
// export const LP = "BNB/USDS LP";
